import { Injectable } from '@angular/core';
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { MentionElement } from '@recruitee/prosemirror';

export class StateUpdated$ extends Subject<Readonly<EditorState>> {}
export class MentionsStream$ extends Observable<MentionElement[]> {}
export class ScrollStream$ extends Observable<void> {}

@Injectable()
export class EditorView$ extends BehaviorSubject<EditorView | null> {}
